module.exports = __webpack_public_path__ + "img/qq.096cdaf7.jpg";